import { disablers } from './body_scroll';
import { disableScroll, enableScroll } from './scrollDisablers';

export function bodyScrollDisable(disablerName: string) {
  const wasDisabled = disablers.size;
  if (!disablers.has(disablerName)) {
    if (!wasDisabled) {
      disableScroll();
    }
    disablers.add(disablerName);
  }
}

export function bodyScrollEnable(disablerName: string) {
  const wasDisabled = disablers.size;
  disablers.delete(disablerName);
  if (!disablers.size && wasDisabled) {
    enableScroll();
  }
}
